import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

export default function ToolReadyHint({ actionLabel }) {
    const { t } = useTranslation();
    return (
        <span>
            {t('toolPage.readyHintBefore')}
            {' '}
            <b className="font-semibold text-primary">{actionLabel}</b>
            {' '}
            {t('toolPage.readyHintAfter')}
        </span>
    );
}
